/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * Creates a privacy and data disclosure statement
 *
 * @module enervee_utils.disclosures
 */
function disclosureStatementDirective() {
    return {
        restrict: 'E',
        scope: {
            cmsKey: '@',
            partnerContext: '=?'
        },
        controllerAs: 'vm',
        bindToController: true,
        controller: disclosureStatementCtrl,
        template: require('./disclosureStatementView.html'),
    };
}

disclosureStatementCtrl.$inject = ['$element', 'UtilService'];

function disclosureStatementCtrl($element, UtilService) {
    this.$onInit = () => {
        const vm = this;
        vm.disclosuresEnabled = UtilService.isFeatureEnabled('compliance_disclosures');
        if (vm.disclosuresEnabled) {
            $element.addClass('compliance-disclosure');
        } else {
            $element.addClass('hidden');
        }
    }
}

module.exports = disclosureStatementDirective;
